import GraphqlBuilder from "utils/request/graphql/builder";
import _ from "lodash";
import QueryBuildingScans from "graphql/queries/management/QueryBuildingScans";
import { bookingConstants, bookingStatus } from 'utils/constants/booking-constants'
import FetchManagementTimeslots from 'utils/fetch/management/FetchManagementTimeslots'

export default class FetchManagementBuilding {
	
	/**
	 * Fetch all the buildings and save them in redux
	 * @param scanInAtDate
	 * @param kind
	 * @param sub_kind
	 * @param bookingDate
	 * @param callbackSuccess
	 * @param callbackError
	 * @param callbackStart
	 */
	static fetchScans = ( { scanInAtDate, kind = bookingConstants.BOOKING, sub_kind = bookingConstants.BOOKING, bookingDate = null, callbackSuccess = null, callbackError = null, callbackStart = null, buildings = null } = {} ) => {
		new GraphqlBuilder()
			.addQuery( 'buildings', QueryBuildingScans, {
				scanInAtDate: scanInAtDate,
				buildings: buildings,
				bookingDate: bookingDate !== null ? bookingDate : [
					scanInAtDate
				],
				bookingKind: kind,
				bookingSubKind: sub_kind,
				bookingStatus: [
					bookingStatus.ACTIVE,
					bookingStatus.INVITE_ACCEPTED,
					bookingStatus.INVITED,
					bookingStatus.EXPIRED
				],
			})
			.setResultPath( ['buildings', 'buildings'], [] )
			.setOnStart( callbackStart )
			.setOnError( callbackError )
			.setOnSuccess( result => {
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						buildings: result
					});
				}
			})
			.execute()
	}
	
	/**
	 * Fetch all the buildings and save them in redux
	 * @param kind
	 * @param subKind
	 * @param callbackSuccess
	 * @param callbackError
	 * @param callbackStart
	 * @param dispatchDataToStore
	 */
	static fetchAllTimeslots = ( { kind = null, subKind = null, callbackSuccess = null, callbackError = null, callbackStart = null, dispatchDataToStore = true } = {} ) => {
		FetchManagementTimeslots.fetchAll({
			kind: kind,
			subKind: subKind,
			dispatchDataToStore,
			callbackError,
			callbackStart,
			callbackSuccess,
		})
	}
}
